/**
 * Composant pour le corps du Modal
 * 
 * @param {Object} props - Les props du composant
 * @param {ReactNode} props.children - Contenu du corps
 * @param {string} props.className - Classes additionnelles
 * @returns {JSX.Element} Le composant ModalBody
 */
const ModalBody = ({ 
  children, 
  className = '' 
}) => {
  return (
    <div className={`${className}`}>
      {children}
    </div>
  )
}

// ModalBody.propTypes = {
//   children: PropTypes.node,
//   className: PropTypes.string
// }

export default ModalBody